"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { ServiceCardProps } from "../../../global";
import AnimatedButton from "../ui/AnimatedButton";
import { getStrapiMedia } from "@/utils/api-helpers";
import { ArrowUpRightIcon } from "@heroicons/react/16/solid";

export default function ServiceCard({
    heading,
    description,
    button,
    slides,
    redirectLink,
    setIsPopupOpen,
}: ServiceCardProps) {
    const handlePopupClick = () => {
        if (setIsPopupOpen) setIsPopupOpen(true);
    };

    // const handleSessionStorage = () => {
    //     sessionStorage.setItem("service", heading);
    // };

    const renderSlideContent = (slide: any, index: number) => {
        const image = (
            <Image
                src={getStrapiMedia(slide.icon.url)}
                alt={slide.icon.alternativeText || ""}
                height={400}
                width={400}
                loading="lazy"
                className="object-cover"
            />
        );

        const overlay = (
            <>
                {slide.name && (
                    <h4 className="absolute left-[10%] right-[10%] bottom-[15%] sm:bottom-[25%] md:bottom-[25%] xl:bottom-[10%] text-sm md:text-xl text-white flex items-end justify-center z-[2] md:gap-x-2">
                        {slide.name}
                        <ArrowUpRightIcon className="h-6 w-6" />
                    </h4>
                )}
                <div className="w-full absolute bottom-0 h-1/2 bg-gradient-to-t from-[#000000] to-transparent bg-opacity-30" />
            </>
        );

        if (slide.hasPopup) {
            return (
                <SwiperSlide
                    key={`${heading}-slide-${index}`}
                    className="service-slide w-[100px] hover:cursor-pointer"
                    onClick={handlePopupClick}
                >
                    {image}
                    {overlay}
                </SwiperSlide>
            );
        }

        return (
            <SwiperSlide
                key={`${heading}-slide-${index}`}
                className="service-slide w-[100px] hover:cursor-pointer"
                // onClick={handleSessionStorage}
            >
                <a
                    href={slide.redirectLink || "#"}
                    className="w-full h-full block"
                >
                    {image}
                    {overlay}
                </a>
            </SwiperSlide>
        );
    };

    return (
        <div className="servicesSlider md:flex md:flex-row-reverse justify-center items-center">
            {/* Image Slider */}
            <div className="flex md:pt-0 md:basis-3/5 md:w-[26.292vw] md:px-8">
                <Swiper
                    spaceBetween={30}
                    centeredSlides
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    pagination={{ clickable: true }}
                    navigation
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper rounded-3xl custom-pagination relative"
                    style={{
                        // @ts-ignore
                        "--swiper-navigation-color": "purple",
                        "--swiper-navigation-sides-offset": "20px",
                        "--swiper-navigation-size": "10px",
                    }}
                >
                    {slides.map(renderSlideContent)}
                </Swiper>
            </div>

            {/* Text Content */}
            <div className="mt-8 md:mt-0 md:basis-2/5 space-y-6">
                <h3 className="text-4xl font-bold">{heading}</h3>
                <p>{description}</p>
                <div
                    className="w-fit"
                    // onClick={handleSessionStorage}
                >
                    <AnimatedButton text="Learn More" link={redirectLink} />
                </div>
            </div>
        </div>
    );
}
